import React, { useEffect, useRef, useState } from "react";
import FrontendLayout from "../../layouts/FrontendLayout";
import { Link } from "react-router-dom";
import api, { API_BASE_URL, fetchData } from "../../api/api";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";
import { BASEURL } from "../../constant/common";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await api.post("add-contacts-enquiries", formData);

      if (response?.data?.status === true) {
        toast.success(response.data?.message);

        setFormData((prevState) => ({
          ...prevState,
          name: "",
          email: "",
          subject: "",
          message: "",
        }));
      } else {
        toast.error(response?.data?.message || "Failed ");
        return null;
      }
    } catch (error) {
      console.error("Error :", error);
      toast.error("Something went wrong. Please try again.");
      return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Contact Us | Allied Health.com.au</title>

        <link rel="canonical" href={BASEURL + '/contact'} />

        <meta
          name="description"
          content="Get in touch with Allied Health.com.au. Contact our support team for inquiries about services, partnerships, or assistance with your Allied health practitioner account."
        />

        <meta
          name="keywords"
          content="contact Allied Health, contact us, Allied Health Australia contact, healthcare support, NDIS inquiries, provider help, allied health services contact, Australian health platform"
        />

        <meta name="robots" content="index, follow" />

        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        <meta charSet="UTF-8" />
      </Helmet>
      <FrontendLayout>
        <section>
          <div className="container mx-auto px-3">
            <h1 className="text-[28px] leading-relaxed sm:text-[39px] sm:leading-[59px] text-dark font-bold text-center my-6 sm:my-8 md:my-12 xl:my-[50px]">
              Contact Us
            </h1>
            <div className="bg-white rounded-[18px] shadow-card py-10 sm:py-12 px-7 sm:px-14 md:px-[110px] mb-[60px] md:mb-[100px]">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-[15px] sm:gap-[24px] lg:gap-[30px]">
                <div>
                  <div className="lg:max-w-[410px] w-100">
                    <h2 className="text-dark text-2xl font-semibold mb-3">
                      How may we assist you?
                    </h2>
                    <p className="text-dark text-lg font-normal mb-[34px]">
                      Fill in the form or drop an email!
                    </p>
                    {/* <div className="border border-[#c2c2c2] rounded-lg px-4 sm:px-5 py-2 sm:py-4 flex gap-3 sm:gap-4 items-center mb-3">
                                            <img src="/assets/image/svg/phoneicon.svg" />
                                                <span className="font-medium text-base sm:text-xl text-dark">+61 00123 4567</span>
                                        </div> */}
                    <div className="border border-[#c2c2c2] rounded-lg px-4 sm:px-5 py-2 sm:py-4 flex gap-3 sm:gap-4 items-center mb-3">
                      <img src="/assets/image/svg/mailicon.svg" />
                      <a
                        href="mailto:info@alliedhealth.com.au"
                        className="font-medium text-base sm:text-xl text-dark"
                      >
                        info@alliedhealth.com.au
                      </a>
                    </div>
                    <div className="border border-[#c2c2c2] rounded-lg px-4 sm:px-5 py-2 sm:py-4 flex gap-3 sm:gap-4 items-center mb-3">
                      <img
                        src="/assets/image/svg/locationicon.svg"
                        className="mb-auto"
                      />
                      <span className="font-medium text-base sm:text-xl text-dark">
                        Suite 703, 155 King Street Sydney NSW 2000
                      </span>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label
                      htmlFor="name"
                      className="mb-2 sm:mb-4 inline-block text-dark font-semibold text-xl"
                    >
                      Your name
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                      id="name"
                      className="border-[1.2px] border-dark w-full h-12 sm:h-14 md:h-[66px] rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl"
                      placeholder="Enter your name"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="email"
                      className="mb-2 sm:mb-4 inline-block text-dark font-semibold text-xl"
                    >
                      Email
                    </label>
                    <input
                      type="text"
                      name="email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                      id="email"
                      className="border-[1.2px] border-dark w-full h-12 sm:h-14 md:h-[66px] rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl"
                      placeholder="Enter your email"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="subject"
                      className="mb-2 sm:mb-4 inline-block text-dark font-semibold text-xl"
                    >
                      Subject
                    </label>
                    <input
                      type="text"
                      name="subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                      id="subject"
                      className="border-[1.2px] border-dark w-full h-12 sm:h-14 md:h-[66px] rounded-xl px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl"
                      placeholder="Enter subject"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="message"
                      className="mb-2 sm:mb-4 inline-block text-dark font-semibold text-xl"
                    >
                      Message
                    </label>
                    <textarea
                      name="message"
                      required
                      value={formData.message}
                      onChange={handleChange}
                      id="message"
                      placeholder="Description"
                      className="border-[1.2px] border-dark w-full h-12 sm:h-14 md:h-[66px] rounded-xl py-4 px-4 sm:px-7 focus:border-blue outline-none text-lg sm:text-xl min-h-36"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    id="register"
                    className="h-auto py-3 px-3 sm:h-14 md:h-[66px] bg-blue w-full text-center text-white font-semibold text-lg sm:text-2xl rounded-xl mb-5 sm:mb-[30px]"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </FrontendLayout>
    </>
  );
};

export default ContactPage;
